export default function ({ app, params, req, store }) {
  const locales = store.state.locales
  const browserLang = (function () {
    if (req && req.headers && req.headers["accept-language"] && process.server)
      return req.headers["accept-language"]
        .split(",")[0]
        .toLocaleLowerCase()
        .substring(0, 2)
    else return "en"
  })()

  if (
    store.state.user.lang === app.$cookies.get("lang") &&
    store.state.user.lang === params.lang
  ) {
    return store.state.user.lang
  } else if (params.lang)
    return locales.includes(params.lang) ? params.lang : "en"
  else return locales.includes(browserLang) ? browserLang : "en"
}
